export default __webpack_public_path__ + "static/media/KOD0069-min.4affbd42.webp";